export const inviteFamilyFriendUserErrorHandler = (errorCode: string) => {
  switch (errorCode) {
    case "PBCOREFriendsAndFamilyUserCreationRestricted":
      return "errors.PBCOREFriendsAndFamilyUserCreationRestricted"
    default:
      return ""
  }
}
